define('components/handlers/kyc-report/bulk-document-order',[
    'jquery',
], function ($) {
    $.extend(companyInfo.handlers, {
        'kyc-report-document-order': function () {
            var orderButton = $(this);
            var spinner = $("#document-order-spinner");
            var dossierID = $('input[name="dossier-id"]').first().val();
            var subDossierID = $('input[name="sub-dossier-id"]').first().val();

            // replace button with spinner
            orderButton.addClass("hidden");
            orderButton.removeClass("submit"); // don't know why, but this is apparently needed to get the element to disappear
            spinner.removeClass("hidden");
            // get all the checked boxes and place document orders at the API
            var promises = placeDocumentOrders(dossierID, subDossierID);
            // then wait until all the orders are finished (the poll function re-enables the order button)
            Promise.all(promises).then(function () {
                    pollReportUntilOrdersAreFinished(dossierID, orderButton, spinner);
                }
            );

            function placeDocumentOrders(dossierID, subDossierID) {
                var promises = [];
                $("[data-official-doc]").filter(':checked').filter(":not(:disabled)").each(function () {
                    var checkBox = $(this);
                    checkBox.attr("disabled", true);
                    var organizationID = checkBox.data("org-id");
                    var documentType = checkBox.data("document-type");
                    promises.push(fetch('/kyc/reports/' + dossierID + '/documents/official-documents', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            organizationID: organizationID,
                            documentType: documentType,
                            subDossierID: subDossierID
                        })
                    }).then(function (response) {
                        if (!response.ok) {
                            checkBox.siblings("[data-failure]").first().removeClass("hidden");
                            checkBox.addClass("hidden");
                            // todo; possibly add user friendly explanation, for now this is ok
                        }
                    }).catch(function (err) {
                        checkBox.siblings("[data-failure]").first().removeClass("hidden");
                        checkBox.addClass("hidden");
                    }));
                });
                return promises;
            }

            function pollReportUntilOrdersAreFinished(reportID, orderButton, spinner) {
                fetch('/kyc/reports/' + reportID + '/json').then(function (res, rej) {
                    if (res.ok) {
                        res.json().then(function (report) {
                            var numOrdersInProgress = 0;
                            report.officialDocuments.forEach(
                                function (officialDocumentEntry) {
                                    numOrdersInProgress += updateOfficialDocumentRecord(officialDocumentEntry);
                                }
                            );
                            if (numOrdersInProgress !== 0) {
                                // call recursively after 5 seconds until all orders are done
                                wait(5000).then(
                                    function (res, rej) {
                                        pollReportUntilOrdersAreFinished(reportID, orderButton, spinner);
                                    });
                            }
                            // this if-statement is needed because of the lack of 'await'
                            if (numOrdersInProgress === 0) {
                                // once all orders are done the recursion should stop and we hit this part where we
                                // make the order button available again
                                spinner.addClass("hidden");
                                orderButton.removeClass("hidden");
                                orderButton.addClass("submit");
                            }
                        });
                    } else {
                        // todo; I really don't know how to error handle everything yet, lets not do it for now in v0.1
                        return rej();
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            }

            // For every row (organization) in the official documents table, this function is called.
            // It in turn tries to update the UI for every document that could be ordered.
            function updateOfficialDocumentRecord(officialDocumentEntry) {
                var numOrdersInProgress = 0;
                numOrdersInProgress += updateSingleDocumentOrder(
                    officialDocumentEntry.organization.id,
                    'extract',
                    officialDocumentEntry.documentOrders.extract
                );
                numOrdersInProgress += updateSingleDocumentOrder(
                    officialDocumentEntry.organization.id,
                    'history',
                    officialDocumentEntry.documentOrders.history
                );
                numOrdersInProgress += updateSingleDocumentOrder(
                    officialDocumentEntry.organization.id,
                    'articles',
                    officialDocumentEntry.documentOrders.articles
                );
                numOrdersInProgress += updateSingleDocumentOrder(
                    officialDocumentEntry.organization.id,
                    'shareholders',
                    officialDocumentEntry.documentOrders.shareholders
                );
                return numOrdersInProgress;
            }

            function updateSingleDocumentOrder(organizationID, documentType, documentOrder) {
                if (documentOrder == null) { // means the user didn't order anything for this company/documentType
                    return 0;
                }
                if (documentOrder.status === "processing") { // in progress means the UI doesn't need updating
                    return 1;
                }
                var baseIdentifier = organizationID + '_' + documentType;
                var checkBoxID = baseIdentifier + '_checkbox';
                var failureIconID = baseIdentifier + '_failure';
                var documentUnavailableIconID = baseIdentifier + '_unavailable';
                var successIconID = baseIdentifier + '_success';

                var checkBox = $("#" + checkBoxID);
                var failureIcon = $("#" + failureIconID);
                var successIcon = $("#" + successIconID);
                var unavailableIcon = $("#" + documentUnavailableIconID);
                if (documentOrder.status === 'finished') {
                    checkBox.addClass("hidden");
                    successIcon.removeClass("hidden");
                }
                if (documentOrder.status === 'failed' && documentOrder.statusCode !== 6) {
                    checkBox.addClass("hidden");
                    failureIcon.removeClass("hidden");
                }
                if (documentOrder.status === 'failed' && documentOrder.statusCode === 6) {
                    checkBox.addClass("hidden");
                    unavailableIcon.removeClass("hidden");
                }
                return 0;
            }

            function wait(ms) {
                return new Promise(function (res, rej) {
                    setTimeout(res, ms);
                });
            }

        },
    });

});

